import { SlIcon } from "@shoelace-style/shoelace/dist/react";

const LocationDetails = ({ data }) => {
    const locations = [data?.sales_person?.dist_name && `${data.sales_person.dist_name} (D)`].filter(Boolean);
    if (!locations.length) return null;

    return (
        <div className="flex flex-wrap gap-1">
            {locations.map((item, index) => (
                <span key={index} className="dz-loc-pill">
                    <SlIcon library="lucide" name="map-pin" style={{ fontSize: "12px" }} />
                    {item}
                </span>
            ))}
        </div>
    );
};

export default LocationDetails;
